/* Saint Rhum redesign: menu, add to cart, cocktail filters and plates */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  // Mobile menu
  var mb = document.getElementById('sr-menu-btn'), mn = document.getElementById('sr-mnav');
  if (mb && mn) {
    mb.addEventListener('click', function () {
      var open = mn.hidden;
      mn.hidden = !open;
      mb.setAttribute('aria-expanded', open);
      mb.textContent = open ? mb.dataset.close : mb.dataset.open;
    });
  }

  // Toast
  var toast, tt;
  function say(html) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'sr-toast';
      toast.setAttribute('role', 'status');
      document.body.appendChild(toast);
    }
    toast.innerHTML = html;
    toast.hidden = false;
    clearTimeout(tt);
    tt = setTimeout(function () { toast.hidden = true; }, 3200);
  }

  function setCount(n) {
    document.querySelectorAll('[data-sr-cart-count]').forEach(function (el) { el.textContent = n; });
  }

  // Add to cart: progressive enhancement over a normal /cart/add form
  function add(variantId, qty, btn) {
    if (btn) btn.disabled = true;
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return fetch(root + 'cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        setCount(cart.item_count);
        say('Added ' + qty + (qty > 1 ? ' bottles' : ' bottle') + ' <a href="' + root + 'cart">View cart</a>');
      })
      .catch(function (e) { say((e && (e.description || e.message)) || 'Sorry, that did not work. Please try again.'); })
      .then(function () { if (btn) btn.disabled = false; });
  }

  document.querySelectorAll('form[data-sr-buy]').forEach(function (form) {
    var out = form.querySelector('[data-sr-qty]'), q = 1;
    var minus = form.querySelector('[data-sr-minus]'), plus = form.querySelector('[data-sr-plus]');
    function render() { if (out) out.textContent = q; }
    if (plus) plus.addEventListener('click', function () { q = Math.min(12, q + 1); render(); });
    if (minus) minus.addEventListener('click', function () { q = Math.max(1, q - 1); render(); });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var bundle = form.querySelector('input[name="quantity"]:checked');
      var n = q * (bundle ? Number(bundle.value) : 1);
      add(form.dataset.variant, n, form.querySelector('button[type=submit]'));
    });
  });

  document.querySelectorAll('[data-sr-add]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      add(b.dataset.srAdd, 1, b);
    });
  });

  // Cocktail illustrations
  if (window.SR_PLATES) {
    document.querySelectorAll('svg[data-plate]').forEach(function (s) {
      var m = window.SR_PLATES[s.dataset.plate];
      if (m) s.innerHTML = m;
    });
  }

  // Cocktail filters
  document.querySelectorAll('[data-sr-filters]').forEach(function (group) {
    var grid = document.getElementById(group.dataset.srFilters);
    group.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        group.querySelectorAll('button').forEach(function (o) { o.setAttribute('aria-pressed', o === b); });
        var f = b.dataset.f;
        grid.querySelectorAll('.sr-card').forEach(function (c) { c.hidden = !(f === 'all' || c.dataset.f === f); });
      });
    });
  });
})();
